import { render } from "./YossiAbulafia.vue?vue&type=template&id=0f6e7b09&scoped=true"
import script from "./YossiAbulafia.vue?vue&type=script&lang=js"
export * from "./YossiAbulafia.vue?vue&type=script&lang=js"

import "./YossiAbulafia.vue?vue&type=style&index=0&id=0f6e7b09&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f6e7b09"]])

export default __exports__